import React from 'react'
import PlusSalonAnalysis from '../components/dashboard/PlusSalonAnalysis'

const PlusSalonAnalysisPage = () => <PlusSalonAnalysis />

export default PlusSalonAnalysisPage
